export default __webpack_public_path__ + "static/media/Activity10.01ab0ef2.jpeg";